(function ($) {
    
    function initArtistSlider() {
        $( '.js-artist-slider' ).not('.slick-initialized').each( function() {
            $( this ).slick( {
                infinite: true,
                slidesToShow: 1,
                arrows: true,
                slidesToScroll: 1,
                appendArrows: $(this).parents('.artist-slider-section').find('.artist-slider-arrows'),
            });
        });
        
        $('.modal-popup').magnificPopup({
            type: 'inline',
            preloader: false,
        });
        $('.popup-video').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,

            fixedContentPos: false
        });
    }
    /* Document Ready */
	$(document).ready(function() {
        initArtistSlider();
	});

})(jQuery);